import { render, staticRenderFns } from "./ProductFamiliesMain.vue?vue&type=template&id=f37dc934&"
import script from "./ProductFamiliesMain.vue?vue&type=script&lang=js&"
export * from "./ProductFamiliesMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports